import { MutationTree } from "vuex";
import {
  IApprovalRequestDetail,
  IApprovalRequestListItem,
  IApprovalRequestsState,
} from "../types";

const mutations: MutationTree<IApprovalRequestsState> = {
  setApprovalRequests(state, payload: IApprovalRequestListItem[]) {
    state.approvalRequests = payload;
  },
  setSelectedApprovalRequest(state, payload: IApprovalRequestDetail | null) {
    state.selectedApprovalRequest = payload;
  },
  setTotalRecords(state, payload: number) {
    state.totalRecords = payload;
  },
  setPage(state, payload: number) {
    state.page = payload;
  },
  setPageSize(state, payload: number) {
    state.pageSize = payload;
  },
  setFetchingApprovalRequests(state, payload: boolean) {
    state.isFetchingApprovalRequests = payload;
  },
  setFetchingApprovalRequestDetail(state, payload: boolean) {
    state.isFetchingApprovalRequestDetail = payload;
  },
  setApprovalRequestActionLoading(state, payload: boolean) {
    state.isApprovalRequestActionLoading = payload;
  },
};

export default mutations;
